
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/federated-id/login",
      function () {
        return require("private-next-pages/federated-id/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/federated-id/login"])
      });
    }
  